import { Menu, Plus } from 'lucide-react';
import { css } from 'styled-system/css';

export function SheetStatus() {
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        gap: '3',
        height: '28px',
        paddingInline: '2',
        background: 'bg.sunken',
        flexShrink: 0,
        color: 'text.faint',
        '& > svg': { width: '12px', height: '12px' },
      })}
    >
      <Plus strokeWidth={2} />
      <Menu strokeWidth={2} />
      <span
        className={css({
          paddingInline: '2',
          paddingBlock: '0.5',
          fontSize: '2xs',
          fontWeight: 'normal',
          color: 'text.muted',
          background: 'bg.surface',
          boxShadow: 'inset 2px 0 0 token(colors.border.default)',
        })}
      >
        Sheet1
      </span>
    </div>
  );
}
